// export const API_URL = "http://15.206.75.239:3000/api";

// export const SOCKET_URL = "ws://15.206.75.239:3000";


 export const API_URL = "https://api.hbn-tech.com/api";
// export const API_URL = "http://localhost:3000/api"; //


export const SOCKET_URL = "https://api.hbn-tech.com";
// export const SOCKET_URL = "http://localhost:3000";

export const GOOGLE_CLIENT_ID="792687090667-s41qucqoogqlbctvv1c2id8j7gvtcq0g.apps.googleusercontent.com";

// export const SOCKET_URL = "ws://localhost:3000";

// export const API_URL = "http://localhost:3000/api";
